export const HOST = {
  RealTime: '//paimai.jd.com',
  SpectalRealTime: '//paimai.jd.com',
  ADDRESS: '//fts.jd.com',
  API: `//${API_HOST}/api`,
  M_AUCTION:'//mauction.jd.com',
  NETINTERFACE: '//api.m.jd.com/api',
};

export const DEFAULT_ERROR_MSG = '网络环境异常，请检查后重试哦！如需帮助，请联系京东资产交易客服400-622-9586';

export const NOT_LOGIN_MSG = '用户未登录';
